// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 27 ? "030037de" : chunkId) + "." + {"27":"fa46b2ede760bd70","139":"e0b8da9815ba2cf2","277":"a6aa604007a310de","986":"5467029f2702e38d"}[chunkId] + ".js";
};